import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Each namespace is owned by the module it belongs to and lives beside the code
// that reads it. This file stays the one place they are registered — i18next
// wants every resource up front.
import enUi from './ui/translations/en-GB.json';
import enPages from './pages/translations/en-GB.json';
import enCommon from './common/translations/en-GB.json';
import enMe from './me/translations/en-GB.json';
import enCompanies from './companies/translations/en-GB.json';
import enTasks from './tasks/translations/en-GB.json';
import enDevices from './devices/translations/en-GB.json';
import enBroadcast from './broadcast/translations/en-GB.json';
import enAnalytics from './analytics/translations/en-GB.json';

import esMXUi from './ui/translations/es-MX.json';
import esESUi from './ui/translations/es-ES.json';
import enUSUi from './ui/translations/en-US.json';
import esMXPages from './pages/translations/es-MX.json';
import esESPages from './pages/translations/es-ES.json';
import enUSPages from './pages/translations/en-US.json';
import esMXCommon from './common/translations/es-MX.json';
import esESCommon from './common/translations/es-ES.json';
import enUSCommon from './common/translations/en-US.json';
import esMXMe from './me/translations/es-MX.json';
import esESMe from './me/translations/es-ES.json';
import enUSMe from './me/translations/en-US.json';
import esMXTasks from './tasks/translations/es-MX.json';
import esESTasks from './tasks/translations/es-ES.json';
import enUSTasks from './tasks/translations/en-US.json';
import esMXDevices from './devices/translations/es-MX.json';
import esESDevices from './devices/translations/es-ES.json';
import enUSDevices from './devices/translations/en-US.json';
import esMXCompanies from './companies/translations/es-MX.json';
import esESCompanies from './companies/translations/es-ES.json';
import enUSCompanies from './companies/translations/en-US.json';
import esMXAnalytics from './analytics/translations/es-MX.json';
import esESAnalytics from './analytics/translations/es-ES.json';
import enUSAnalytics from './analytics/translations/en-US.json';
import esMXBroadcast from './broadcast/translations/es-MX.json';
import esESBroadcast from './broadcast/translations/es-ES.json';
import enUSBroadcast from './broadcast/translations/en-US.json';

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // No `lng`: setting it bypasses the detector entirely. The detector is
        // limited to the query string, so nobody's browser language silently
        // switches them — `?lng=es-MX` is opt-in, for checking a translation.
        fallbackLng: 'en-GB',
        detection: {
            order: ['querystring'],
            lookupQuerystring: 'lng',
            caches: []
        },
        ns: [
            'common',
            'pages',
            'ui',
            'me',
            'companies',
            'tasks',
            'devices',
            'broadcast',
            'analytics'
        ],
        defaultNS: 'common',
        supportedLngs: ['en-GB', 'en-US', 'es-MX', 'es-ES'],
        resources: {
            'en-GB': {
                common: enCommon,
                pages: enPages,
                ui: enUi,
                me: enMe,
                companies: enCompanies,
                tasks: enTasks,
                devices: enDevices,
                broadcast: enBroadcast,
                analytics: enAnalytics
            },
            'en-US': {
                common: enUSCommon,
                pages: enUSPages,
                ui: enUSUi,
                me: enUSMe,
                companies: enUSCompanies,
                tasks: enUSTasks,
                devices: enUSDevices,
                analytics: enUSAnalytics,
                broadcast: enUSBroadcast
            },
            'es-MX': {
                common: esMXCommon,
                pages: esMXPages,
                ui: esMXUi,
                me: esMXMe,
                companies: esMXCompanies,
                tasks: esMXTasks,
                devices: esMXDevices,
                analytics: esMXAnalytics,
                broadcast: esMXBroadcast
            },
            'es-ES': {
                common: esESCommon,
                pages: esESPages,
                ui: esESUi,
                me: esESMe,
                companies: esESCompanies,
                tasks: esESTasks,
                devices: esESDevices,
                analytics: esESAnalytics,
                broadcast: esESBroadcast
            }
        },
        interpolation: {
            escapeValue: false // not needed for react!!
        }
    })
    .catch((err) => {
        throw err;
    });

export default i18next;
